import React from 'react';
import { ArrowRightIcon, TimerIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { pad2 } from './Shared';
export function AnnouncementBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-50 border-b border-white/10 bg-slate-950/85 backdrop-blur-md" data-id="element-21" data-mp="js915i6dhovl">
      <div className="mx-auto flex h-11 max-w-6xl items-center justify-center gap-3 px-4 text-xs md:text-sm" data-id="element-22" data-mp="euqopht5criu">
        <TimerIcon size={15} className="hidden shrink-0 text-sky-400 sm:block" aria-hidden="true" data-id="element-23" data-mp="9tt8vbvm09ki" />
        <p className="min-w-0 truncate text-slate-300" data-id="element-24" data-mp="5wf1zqveidvo">
          <span className="sm:hidden" data-id="element-25" data-mp="wah7ongmwzn">Koniec za</span>
          <span className="hidden sm:inline" data-id="element-26" data-mp="x2cszh24upx">Promocja kończy się za</span>{' '}
          <span className="font-display font-extrabold tabular-nums text-white" data-id="element-27" data-mp="3s3dcosabzpfo">
            {pad2(hours)}:{pad2(minutes)}:{pad2(seconds)}
          </span>
        </p>
        <a href="#pricing" className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-white/10 px-3 py-1 font-semibold text-white transition-colors duration-150 hover:bg-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400" data-id="element-28" data-mp="1qb79lqnh00d3">
          Odbierz za 79 zł <ArrowRightIcon size={13} aria-hidden="true" data-id="element-29" data-mp="3sh1fani1b10h" />
        </a>
      </div>
    </div>;
}